import {intlLocale} from '../../languages';
import React from 'react';
import {useTranslation} from 'react-i18next';
import useViewportVisibility from '../../hooks/useViewportVisibility';

const imagesByPath = import.meta.glob('../../public/examples/**/*.webp', {eager: true, query: '?url', import: 'default'});

const Examples = () => {
    const {t, i18n} = useTranslation();
    const {ref, entered} = useViewportVisibility();
    const countryNames = new Intl.DisplayNames([intlLocale(i18n.language)], {type: 'region'});
    const images = [
        {path: '600x720/1-v2', countries: ['GB']},
        {path: '600x600/1-v2', countries: ['DE']},
        {path: '600x480/1-v2', countries: ['DE', 'GB']},
        {path: '600x600/2-v2', countries: ['SE', 'FI']},
        {path: '600x480/2-v2', countries: ['BE']},
        {path: '600x720/2-v2', countries: ['US']},
        {path: '600x480/3-v2', countries: ['SE']},
        {path: '600x720/3-v2', countries: ['IT']},
        {path: '600x600/3-v2', countries: ['IT']},
        {path: '600x600/4-v2', countries: ['PL']},
        {path: '600x720/4-v2', countries: ['DE']},
        {path: '600x480/4-v2', countries: ['GB']},
    ];
    return (
        <section id="examples" className="design-section examples-section">
            <div className="design-container">
                <h2>{t('examples.title')}</h2>
                <p className="section-subtitle">{t('examples.subtitle')}</p>
            </div>
            <div ref={ref} className="example-ribbon" tabIndex="0" role="region" aria-label={t('header.examples')}>
                {entered && images.map(({path, countries}) => {
                    const small = imagesByPath[`../../public/examples/${path}-320.webp`];
                    const large = imagesByPath[`../../public/examples/${path}-600.webp`];
                    return <img key={path} src={large} srcSet={`${small} 320w, ${large} 600w`} sizes="(max-width: 377px) 72vw, 272px" alt={t('examples.imageAlt', {places: countries.map(code => countryNames.of(code)).join(', ')})} loading="lazy" decoding="async" width="272" height="272"/>;
                })}
            </div>
        </section>
    );
};
export default Examples;
